/* eslint-disable no-unused-vars */
import { Delete, Get, Post, PostFormData, Put } from "../Request";

export default {
  state: {
    Products: [],
    ProductCategories: [],
    Stock: [],
    setproducts: [],
    GetSelectedRelatedproducts: [],
    selectedRelatedProducts: [],
    ProductsUpdateInventory:[],
    storeItemById:[]
  },
  getters: {
    GetProducts(state) {
      return state.Products;
    },
    GetProductsUpdateInventory(state) {
      return state.ProductsUpdateInventory;
    },
    GetProductCategories(state) {
      return state.ProductCategories;
    },
    GetStockHistorty(state) {
      return state.Stock;
    },
    GetStoreById(state) {
      return state.storeItemById;
    },
    GetSelectedRelatedproducts(state) {
      return state.selectedRelatedProducts;
    },
  },
  actions: {
    async GetProducts({ commit }, payload) {
      return await Get(
        `Store/GetStoreProducts?page=${payload.page}&pageSize=${payload.pageSize}&search=${payload.search}&filters=${payload.filters}`
      ).then((res) => {
        commit("SetProducts", res.data.Data.List);
        return res.data.Data;
      });
    },
    async GetProductsUpdateInventory({ commit }, payload) {
      return await Get(
        `Store/GetStoreProducts?page=${payload.page}&pageSize=${payload.pageSize}&search=${payload.search}&filters=${payload.filters}`
      ).then((res) => {
        commit("SetProductsUpdateInventory", res.data.Data.List);
        return res.data.Data;
      });
    },

    async GetProductCategories({ commit }, payload) {
      return await Get("Store/GetAllStoreProductCategory").then((res) => {
        commit("SetProductCategories", res.data.Data);
        return res.data;
      });
    },

    async GetStockHistorty({ commit }, payload) {
      return await Get(`Store/StoreInventoryHistory?Id=${payload}`).then(
        (res) => {
          commit("SetStockHistorty", res.data.Data);
          return res.data;
        }
      );
    },
    async AddStoreProductCategory({ commit }, payload) {
      return await Post("Store/AddStoreProductCategory", payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async UpdateOrderShipAndReceivedDate({ commit }, payload) {
      return await Post(`Store/UpdateOrderShipAndReceivedDate?id=${payload.id}&status=${payload.status}&dateTime=${payload.dateTime}`).then(
        (res) => {
          return res.data;
        }
      );
    },
    async ToggleStoreVisibility({ commit }, payload) {
      return await Put(`Store/ToggleStoreVisibility?Id=${payload}`).then(
        (res) => {
          return res.data;
        }
      );
    },
    // async GetStoreById({ commit }, payload) {
    //   return await Get(`Store/GetStoreProductsById?Id=${payload.Id}&isWebApp=false`).then((res) => {
    //     commit("SetRelatedProducts", res.data);
    //     return res.data;
    //   });
    // },
    async GetStoreById({ commit }, payload) {
      try {
        const response = await Get(
          `Store/GetStoreProductsById?Id=${payload.Id}&isWebApp=${payload.isWebApp}`
        );
        commit("SetRelatedProducts", response.data);
        commit("SetStoreProductsById", response.data);
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
      }
    },
    async UpdateStoreInventory({ commit }, payload) {
      return await Put("Store/UpdateStoreInventory", payload).then((res) => {
        return res.data;
      });
    },
    async AddStoreStock({ commit }, payload) {
      return await Post("Store/AddStock", payload).then((res) => {
        return res.data;
      });
    },
    async AddStoreProduct({ commit }, payload) {
      return await Post("Store/AddStoreProduct", payload).then((res) => {
        return res.data;
      });
    },
    async SortStoreProductCategory({ commit }, payload) {
      return await Get(`Store/SortStoreProductCategory?sortNum=${payload.sortNum}&Id=${payload.Id}`).then(
        (res) => {
          return res.data;
        }
      );
    },
    async EditStoreProduct({ commit }, payload) {
      return await Put("Store/EditStoreProduct", payload).then((res) => {
        return res.data;
      });
    },
    async EditStoreProductCategory({ commit }, payload) {
      return await Put("Store/EditStoreProductCategory", payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async RemoveStoreProductCategory({ commit }, payload) {
      return await Delete(`Store/RemoveStoreProductCategory/${payload}`).then(
        (res) => {
          return res.data;
        }
      );
    },
    async DeleteStore({ commit }, payload) {
      return Delete(`Store/DeleteStoreProduct/${payload}`).then((res) => {
        return res.data;
      });
    },
    async SetRelatedProducts({ commit }, payload) {
      commit("SetRelatedProduct", payload);
    },
    async selectRelatedCoureseEmpty({ commit }, payload) {
      commit("SetRelatedCoureseEmpty",payload);
    },
    RemoveSelectedProduct({ commit }, payload) {
      commit("RemoveSelectedProduct", payload);
    },
  },
  mutations: {
    SetRelatedProducts(state, payload) {
      state.selectedRelatedProducts = payload;
    },
    SetStoreProductsById(state, payload) {
      state.storeItemById = payload;
    },
    SetProductCategories(state, payload) {
      state.ProductCategories = payload;
    },
    SetStockHistorty(state, payload) {
      state.Stock = payload;
    },
    SetProducts(state, payload) {
      payload = payload.map((x) => {
        x.CoverImage =
          x.CoverImage != null &&
          x.CoverImage != undefined &&
          x.CoverImage != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + x.CoverImage
            ? x.CoverImage
            : x.CoverImage;
        x.Image1 =
          x.Image1 != null && x.Image1 != undefined && x.Image1 != ""
            ? x.Image1
            : x.Image1;
        x.Image2 =
          x.Image2 != null && x.Image2 != undefined && x.Image2 != ""
            ? x.Image2
            : x.Image2;
        x.Image3 =
          x.Image3 != null && x.Image3 != undefined && x.Image3 != ""
            ? x.Image3
            : x.Image3;
        x.Image4 =
          x.Image4 != null && x.Image4 != undefined && x.Image4 != ""
            ? x.Image4
            : x.Image4;

        return x;
      });
      state.Products = payload;

    },
    SetProductsUpdateInventory(state, payload) {
      payload = payload.map((x) => {
        x.CoverImage =
          x.CoverImage != null &&
          x.CoverImage != undefined &&
          x.CoverImage != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + x.CoverImage
            ? x.CoverImage
            : x.CoverImage;
        x.Image1 =
          x.Image1 != null && x.Image1 != undefined && x.Image1 != ""
            ? x.Image1
            : x.Image1;
        x.Image2 =
          x.Image2 != null && x.Image2 != undefined && x.Image2 != ""
            ? x.Image2
            : x.Image2;
        x.Image3 =
          x.Image3 != null && x.Image3 != undefined && x.Image3 != ""
            ? x.Image3
            : x.Image3;
        x.Image4 =
          x.Image4 != null && x.Image4 != undefined && x.Image4 != ""
            ? x.Image4
            : x.Image4;

        return x;
      });
      state.ProductsUpdateInventory = payload;
    },
    SetRelatedStore(state, payload) {
      state.setproducts = payload;
    },
    SetRelatedCoureseEmpty(state, payload) {
      state.selectedRelatedProducts = payload
    },
    SetRelatedProduct(state, payload) {
      if (
        state.selectedRelatedProducts.find((x) => x.Id === payload.Id) == null
      ) {
        state.selectedRelatedProducts.push(payload);
      } else {
        state.selectedRelatedProducts = state.selectedRelatedProducts.filter(
          (x) => x.Id !== payload.Id
        );
      }
    },
    RemoveSelectedProduct(state, payload) {
      if(payload == "cancel"){
        state.selectedRelatedProducts = []
        return
      }
      state.selectedRelatedProducts = state.selectedRelatedProducts.filter(
        (x) => x.Id !== payload.Id
      );
    },
  },
};
